import { render, staticRenderFns } from "./FileUploadButton.vue?vue&type=template&id=19c0f1c0&scoped=true&"
import script from "./FileUploadButton.vue?vue&type=script&lang=js&"
export * from "./FileUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0f1c0",
  null
  
)

export default component.exports